// Shared by prerendering and client navigation so a route never inherits another page's schema.
export function createStructuredData({ page, locale, canonical, siteOrigin, title, description, isHome, article }) {
  const website = {
    '@type': 'WebSite', '@id': `${siteOrigin}/#website`, name: 'Suno Download',
    ...(siteOrigin ? { url: `${siteOrigin}/` } : {}),
  };
  const publisher = { '@type': 'Organization', name: 'Suno Download' };
  let data;
  if (page === 'downloader' || page === 'promptBuilder') {
    const application = {
      '@type': 'WebApplication', '@id': `${canonical}#application`,
      name: page === 'promptBuilder' ? 'Suno Prompt Builder'
        : canonical.endsWith('/tools/batch-downloader/') ? 'Suno Bulk Downloader' : 'Suno Downloader',
      inLanguage: locale, url: canonical, publisher,
      applicationCategory: 'MultimediaApplication', operatingSystem: 'Any', description,
      isAccessibleForFree: true, offers: { '@type': 'Offer', price: 0, priceCurrency: 'USD' },
      isPartOf: { '@id': website['@id'] },
    };
    data = isHome ? { '@graph': [website, application] } : application;
  } else if (page === 'article') {
    data = { '@type': 'Article', inLanguage: locale, headline: article.title, description,
      mainEntityOfPage: canonical, author: publisher, publisher };
  } else {
    data = { '@type': ['articles', 'tools'].includes(page) ? 'CollectionPage' : page === 'toolInfo' ? 'WebPage' : 'AboutPage',
      inLanguage: locale, name: title, description, url: canonical, isPartOf: website };
  }
  return { '@context': 'https://schema.org', ...data };
}
